import { render, staticRenderFns } from "./matter_add.vue?vue&type=template&id=525b3462&scoped=true&"
import script from "./matter_add.vue?vue&type=script&lang=js&"
export * from "./matter_add.vue?vue&type=script&lang=js&"
import style0 from "./matter_add.vue?vue&type=style&index=0&id=525b3462&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525b3462",
  null
  
)

export default component.exports